export default function ChatbotTestimonial() {
  return (
    <div className="mt-[100px]">
      <div className="flex flex-col justify-start lg:max-w-[45%] sm:max-w-[70%] sm:mx-auto mx-2 bg-gray-100 rounded-lg text-center text-gray-700 font-light p-5">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="24"
          viewBox="0 0 28 24"
          fill="currentColor"
        >
          <path
            d="M12.5427 22.1916V22.2913H12.543C12.4885 23.1839 11.7064 23.9003 10.7403 23.9003H1.90542C0.903648 23.9003 0.0996678 23.13 0.0996678 22.1916V11.9984C0.0996678 5.46229 5.65554 0.150835 12.5427 0.100035V5.04223C8.5494 5.09291 5.31752 8.18441 5.31752 11.9984V12.0981H5.41719H10.7369C11.7387 12.0981 12.5427 12.8684 12.5427 13.8068V22.1916ZM20.6718 11.9984V12.0981H20.7715H26.0912H26.0946C27.0964 12.0981 27.9003 12.8684 27.9003 13.8068V22.1916C27.9003 23.13 27.0964 23.9003 26.0946 23.9003H17.2597C16.2579 23.9003 15.454 23.13 15.454 22.1916V11.9984C15.454 5.46229 21.0098 0.150836 27.897 0.100035V5.04223C23.9037 5.09291 20.6718 8.18441 20.6718 11.9984Z"
            stroke="white"
            strokeWidth="0.199336"
          />
        </svg>
        <div className="mt-5 text-[16px] md:text-[20px]">
          Implementing the AI sales chatbot transformed our customer
          interactions. It's like having a 24/7 sales expert on hand, instantly
          answering questions and guiding leads through the sales journey. The
          result? More conversions, happier customers, and a smoother workflow
          for our team. With personalized recommendations, real-time lead
          scoring, and seamless CRM integration, it’s revolutionized our sales
          process. Truly a game-changer for driving growth and efficiency.
        </div>
        <div className="mt-5 text-[14px] md:text-[16px] text-gray-700 font-medium">
          <div> - ANSHUMALI BHUSAN,</div>
          <div className="text-gray-600 text-[10px]">CEO Of Genesis</div>
        </div>
      </div>
    </div>
  );
}
